import { graphqlSdk } from '../../../../Utils/graphql-client';

export const loadBookingMinimalShops = async (
  city: string | undefined,
  country: string | undefined
) => {
  console.log('loadBookingMinimalShops', city, country);
  const minimalShops = await graphqlSdk.booking_getMinimalShops({
    city,
    country,
  });

  const visibleShops = minimalShops.getShops.filter((shop) => !shop.hidden);

  return visibleShops;
};
